__turbopack_context__.v({
  "contentWrapper": "kTzQfG_contentWrapper",
  "menuContent": "kTzQfG_menuContent",
  "popupHeader": "kTzQfG_popupHeader",
  "tabletContent": "kTzQfG_tabletContent",
  "title": "kTzQfG_title",
  "wrapper": "kTzQfG_wrapper",
});
